/* eslint-disable import/prefer-default-export */
import { sortBy } from 'lodash';

const statuses = {
  EXPIRED: 'Expired',
  PENDING: 'Pending',
};

const mappedUsers = users => users.map((user) => {
  const {
    email,
    hasActiveJobs,
    id,
    isCurrentUser,
    lastActive,
    name,
    policy: { role },
  } = user;

  return {
    email,
    hasActiveJobs,
    id,
    isCurrentUser,
    key: name,
    lastActive,
    role,
    type: 'user',
  };
});

const mappedInvitations = invitations => invitations.map((invitation) => {
  const {
    canResend,
    id,
    receiverRole,
    recipientEmail,
    status,
  } = invitation;

  return {
    id,
    key: recipientEmail,
    receiverRole,
    status: statuses[status],
    type: 'invitation',
    canResend,
  };
});

export const mapUsersAndInvitations = (users, invitations) => {
  if (!users || !invitations) return [];

  const mappedList = [
    ...mappedUsers(users),
    ...mappedInvitations(invitations),
  ];

  const result = sortBy(mappedList, [item => item.key.toLowerCase()]);

  return result;
};

